import React from 'react';
import Icon from '../../../components/AppIcon';

const WhatMakesCynizeeDifferent = () => {
  const pillars = [
    { icon: 'Target', label: 'Clearer family expectations', desc: 'Everyone knows what is expected, when it is due, and what happens next.', color: '#ff6b6b' },
    { icon: 'Sun', label: 'Better daily routines', desc: 'Consistent structure that kids can follow independently every day.', color: '#f59e0b' },
    { icon: 'TrendingUp', label: 'Stronger independence in children', desc: 'Kids take ownership of their responsibilities without constant reminders.', color: '#2dd4bf' },
    { icon: 'Heart', label: 'Less stress for parents', desc: 'Spend less time nagging and more time enjoying family moments.', color: '#a78bfa' },
  ];

  return (
    <section className="py-24 relative overflow-hidden" style={{background: '#0f1f3d'}}>
      {/* Background texture */}
      <div className="absolute inset-0 opacity-[0.04]" style={{backgroundImage: 'radial-gradient(circle, rgba(255,255,255,0.8) 1px, transparent 1px)', backgroundSize: '32px 32px'}}></div>
      <div className="absolute top-0 right-0 w-96 h-96 rounded-full opacity-10 blur-3xl" style={{background: 'radial-gradient(circle, #2dd4bf, transparent)'}}></div>
      <div className="absolute bottom-0 left-0 w-72 h-72 rounded-full opacity-10 blur-3xl" style={{background: 'radial-gradient(circle, #ff6b6b, transparent)'}}></div>
      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 mb-6 px-4 py-2 rounded-full text-sm font-bold uppercase tracking-widest" style={{background: 'rgba(255,107,107,0.15)', color: '#ff8a8a', border: '1px solid rgba(255,107,107,0.3)'}}>
            <Icon name="Zap" size={14} />
            What Makes Us Different
          </div>
          <h2 className="font-heading font-bold leading-tight mb-6 text-white" style={{fontSize: 'clamp(2rem, 4vw, 3.2rem)'}}>
            More than a chore app.{' '}
            <span style={{color: '#2dd4bf'}}>A full accountability system.</span>
          </h2>
          <p className="text-lg max-w-2xl mx-auto" style={{color: 'rgba(255,255,255,0.6)'}}>
            Most chore apps stop at task lists. Cynizee goes further — managing the full process from assignment to approval, so kids know exactly what happens if they don't follow through.
          </p>
        </div>

        {/* Main layout: big statement + pillars */}
        <div className="grid lg:grid-cols-5 gap-6">
          
          {/* Big statement card */}
          <div className="lg:col-span-3 rounded-3xl p-8 sm:p-10 relative overflow-hidden" style={{background: 'linear-gradient(135deg, #ff6b6b 0%, #ff4444 100%)'}}>
            <div className="absolute top-0 right-0 w-48 h-48 rounded-full opacity-20 blur-2xl" style={{background: '#fff'}}></div>
            <div className="absolute -bottom-8 -left-8 w-40 h-40 rounded-full opacity-10 blur-2xl" style={{background: '#0f1f3d'}}></div>
            <div className="relative z-10">
              <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-6" style={{background: 'rgba(255,255,255,0.2)'}}>
                <Icon name="Shield" size={28} className="text-white" />
              </div>
              <div className="inline-flex items-center gap-2 mb-4 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide" style={{background: 'rgba(255,255,255,0.2)', color: '#fff'}}>
                ⭐ The Cynizee Difference
              </div>
              <h3 className="font-heading font-bold text-white leading-tight mb-4" style={{fontSize: 'clamp(1.4rem, 3vw, 2rem)'}}>
                Parents get more clarity, more control, and less daily back-and-forth.
              </h3>
              <p className="leading-relaxed" style={{color: 'rgba(255,255,255,0.8)'}}>
                Cynizee supports the full accountability loop — from the moment a chore is assigned to the moment a parent approves it. No more guessing, no more repeating yourself.
              </p>
              {/* Divider */}
              <div className="mt-6 pt-6 border-t" style={{borderColor: 'rgba(255,255,255,0.2)'}}>
                <div className="flex items-center gap-3">
                  <Icon name="Lock" size={18} className="text-white" />
                  <span className="text-white font-semibold text-sm">Favorite apps lock when chores aren't done</span>
                </div>
              </div>
            </div>
          </div>

          {/* Pillars */}
          <div className="lg:col-span-2 flex flex-col gap-4">
            <p className="text-xs font-bold uppercase tracking-widest mb-1" style={{color: 'rgba(255,255,255,0.4)'}}>Cynizee is designed to support:</p>
            {pillars?.map((pillar, i) => (
              <div
                key={i}
                className="rounded-2xl p-5 flex items-start gap-4 transition-all duration-300 hover:scale-[1.02] cursor-default"
                style={{background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)'}}
              >
                <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style={{background: `${pillar?.color}25`}}>
                  <Icon name={pillar?.icon} size={18} style={{color: pillar?.color}} />
                </div>
                <div>
                  <h4 className="font-heading font-semibold text-white text-sm mb-1">{pillar?.label}</h4>
                  <p className="text-xs leading-relaxed" style={{color: 'rgba(255,255,255,0.5)'}}>{pillar?.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatMakesCynizeeDifferent;